import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { H2, H3, Button, MarkdownWrapper } from 'components/atoms';
import { Container } from 'components/core/Page';
import { UnitSizeComparison } from 'components/molecules';
import './SizeComparisonSection.scss';
import unitSizeImage from 'assets/images/psp/sizeComparisionDefault.png';

export function SizeComparisonSection({ content, storageData }) {
	const {
		title,
		description,
		image = unitSizeImage,
		contentdec,
		contentAlign,
	} = content;
	const [selectedSize, setSelectedSize] = useState(storageData[0]?.size);

	const selectedItem = useMemo(
		() => storageData.find((item) => item.size === selectedSize),
		[selectedSize, storageData],
	);

	return (
		<section className="vehicle-storage-section">
			<Container>
				<UnitSizeComparison icon={image} />
				<div className="vehicle-storage-content">
					<H2>{title}</H2>
					<MarkdownWrapper
						className="vehicle-dec"
						content={[{ value: description }]}
					/>
				</div>

				<div className="centered-square-box">
					<div className="storage-buttons">
						{storageData.map(({ size }) => (
							<Button
								key={size}
								className={`storage-button ${selectedSize === size ? 'active' : ''}`}
								onClick={() => setSelectedSize(size)}
							>
								{size}
							</Button>
						))}
					</div>
					{selectedItem && (
						<div className="storage-description">
							<H3>{selectedItem.heading}</H3>
							<MarkdownWrapper
								content={selectedItem.desc.map((point) => ({
									value: point,
								}))}
							/>
						</div>
					)}
				</div>
				<MarkdownWrapper
					content={[{ value: contentdec }]}
					componentProps={{ color: 'black' }}
					className={contentAlign ? contentAlign : 'text-left'}
				/>
			</Container>
		</section>
	);
}

SizeComparisonSection.propTypes = {
	content: PropTypes.shape({
		title: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		image: PropTypes.string.isRequired,
		contentdec: PropTypes.string.isRequired,
		contentAlign: PropTypes.string,
	}).isRequired,
	storageData: PropTypes.arrayOf(
		PropTypes.shape({
			size: PropTypes.string.isRequired,
			heading: PropTypes.string.isRequired,
			desc: PropTypes.arrayOf(PropTypes.string).isRequired,
		}),
	).isRequired,
};
export default SizeComparisonSection;
